import {Component, Input, Output, EventEmitter} from '@angular/core';

@Component({
    selector: 'label-input-pair',
    templateUrl: './label-input-pair.component.html',
    styleUrls: ['./label-input-pair.component.css']
})
export class LabelInputPairWidget {
	@Input() label:string;
	private  _required:any;
	private  _disabled:any;
	@Input() model:any;
	@Input() type:string;
	@Input() additionalInfo:string;
	@Input() icon:string;
    @Input() invalid: boolean = false;
	@Input() large:boolean;
	@Input() placeholder:string;
	@Input() pattern:string;
	@Input() helpMessage;

	@Output() modelChange: EventEmitter<any> = new EventEmitter();


	@Input()
	set required(required: string) {
		this._required = required === "" || required === "true";

	}

	get required(): string { return this._required; }

	@Input()
	set disabled(disabled: string) {
		this._disabled = disabled === "" || disabled === "true";

	}

	get disabled(): string { return this._disabled; }


	onChanges(newValue) {
		this.model = newValue;
		this.modelChange.emit(newValue);
	}
}
